/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const CustomersAiIcon = ({
  className,
  style: styleFromProps,
  onClick,
  size,
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      style={style}
      className={classNames(className)}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M11.9378 15.9308L8.28489 16.6068C4.65353 17.2788 1.164 14.8841 0.490968 11.2582C-0.182065 7.6322 2.21619 4.14786 5.84755 3.47583L9.50046 2.7998L10.1775 6.44729L6.52457 7.12331C4.91077 7.42196 3.84472 8.97063 4.14384 10.5821C4.44296 12.1936 5.99396 13.258 7.60783 12.9593L11.2607 12.2833L11.9378 15.9308Z"
        fill="#2F54EB"
      />
      <path
        d="M15.2998 15.2117L14.725 11.668L11.2647 12.3972L11.8394 15.941L15.2998 15.2117Z"
        fill="white"
      />
      <path
        d="M13.5406 5.72053L12.9659 2.17676L9.50553 2.90599L10.0803 6.44976L13.5406 5.72053Z"
        fill="white"
      />
      <path
        d="M6.19317 5.30071C6.39469 5.26336 6.52792 5.0695 6.49057 4.86799C6.45322 4.66648 6.25937 4.53324 6.05785 4.57059C5.85634 4.60794 5.72311 4.80179 5.76046 5.00331C5.7978 5.20482 5.99166 5.33805 6.19317 5.30071Z"
        fill="white"
      />
      <path
        d="M12.7855 1.8061L5.78233 3.10716C1.96102 3.81709 -0.571661 7.51098 0.136584 11.3415C0.844829 15.172 4.52994 17.7107 8.35125 17.0008L15.3544 15.6997C15.5558 15.6623 15.6889 15.4682 15.6515 15.2663L14.9755 11.6101C14.9382 11.4082 14.7446 11.2748 14.5432 11.3123L7.53999 12.6133C6.13213 12.8749 4.77445 11.9395 4.51352 10.5283C4.25308 9.11975 5.17716 7.75775 6.59356 7.4946L13.5967 6.19354C13.7982 6.15611 13.9312 5.96205 13.8939 5.76015L13.2179 2.10396C13.1805 1.90206 12.987 1.76867 12.7855 1.8061ZM12.2283 15.5241L11.6875 12.5991L14.3137 12.1112L14.8545 15.0362L12.2283 15.5241ZM3.78405 10.6638C4.11954 12.4783 5.86512 13.6808 7.67519 13.3445L10.9579 12.7347L11.4987 15.6596L8.21601 16.2695C4.79695 16.9047 1.49974 14.6332 0.866049 11.2059C0.232363 7.77871 2.49848 4.47361 5.91754 3.83841L9.20026 3.22854L9.74108 6.15352L6.45836 6.76339C4.65168 7.09904 3.44655 8.83846 3.78405 10.6638ZM13.0968 5.53009L10.4706 6.01799L9.92976 3.09301L12.556 2.60511L13.0968 5.53009Z"
        fill="#262626"
      />
      <path
        d="M4.88679 5.74233C5.06957 5.64936 5.14253 5.42586 5.04944 5.24306C4.95651 5.06031 4.73299 4.98747 4.5502 5.08041C3.50118 5.61388 2.6301 6.49038 2.09747 7.54842C2.00529 7.7315 2.07896 7.95479 2.26215 8.04699C2.44527 8.13921 2.66851 8.06547 2.76072 7.88231C3.22269 6.96458 3.9778 6.20461 4.88679 5.74233Z"
        fill="white"
      />
      <path
        d="M17.8831 2.93229C17.9402 2.73553 17.8259 2.53005 17.6279 2.47338L16.0251 2.01449C15.9009 1.97892 15.767 2.00985 15.6713 2.0962C15.5756 2.18255 15.5316 2.31204 15.5552 2.4384L15.7171 3.30683L14.6941 3.01396C14.4962 2.95729 14.2895 3.07087 14.2325 3.26771C14.1753 3.46514 14.2904 3.67016 14.4877 3.72662L16.0905 4.18551C16.2147 4.22108 16.3486 4.19015 16.4443 4.1038C16.5401 4.01745 16.584 3.88796 16.5604 3.7616L16.3986 2.89317L17.4215 3.18604C17.6194 3.24268 17.8261 3.12909 17.8831 2.93229Z"
        fill="#262626"
      />
      <path
        d="M19.7631 13.1716C19.8202 12.9748 19.7059 12.7693 19.5079 12.7126L17.9051 12.2537C17.7809 12.2182 17.647 12.2491 17.5513 12.3355C17.4556 12.4218 17.4116 12.5513 17.4352 12.6777L17.5971 13.5461L16.5741 13.2532C16.3762 13.1965 16.1695 13.3101 16.1125 13.507C16.0553 13.7044 16.1704 13.9094 16.3677 13.9659L17.9705 14.4248C18.0947 14.4603 18.2286 14.4294 18.3243 14.3431C18.4201 14.2567 18.464 14.1272 18.4405 14.0009L18.2786 13.1324L19.3015 13.4253C19.4994 13.4819 19.7061 13.3684 19.7631 13.1716Z"
        fill="#262626"
      />
    </svg>
  );
};
